export default {
  string: {
    contains: "contains",
    ncontains: "doesn't contain",
  },
  dateTime: {
    gte: "in",
  },
};
